import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import { StyledModalImageThumbnail } from 'LuxKit/Modal/ModalImageThumbnail'
import { usePlaceImages } from 'tripPlanner/hooks/Google/usePlaceImages'

const CoverImage = styled.img`
  display: inline;
  object-fit: cover;
  width: 100%;
  height: ${rem(360)};
`

type Props = {
  placeId: string
  title: string
  tripId: string
  tripItemId: string
  maxWidth?: number
}
function SummaryGoogleImage({
  tripId,
  tripItemId,
  maxWidth,
  placeId,
  title,
}: Props) {
  const { data: images, isLoading } = usePlaceImages({
    placeId,
    maxWidthPx: maxWidth,
    tripId,
    tripItemId,
  })
  const photoUrl = images?.[0]?.url
  if (isLoading || !photoUrl) return null

  return (
    <StyledModalImageThumbnail>
      <CoverImage src={photoUrl} alt={title} />
    </StyledModalImageThumbnail>
  )
}
export default SummaryGoogleImage
